import { ChangeEvent, Dispatch, SetStateAction, useState } from 'react';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Buttons from '../Buttons/Buttons';
import { ReactComponent as OpenIcon } from '../../assets/Icons/chevron/Chevron-Down.svg';
import { ReactComponent as CloseIcon } from '../../assets/Icons/chevron/Chevron-Up.svg';
import { ReactComponent as ColumnsIcon } from '../../assets/Icons/adornments/Column.svg';
import { TableHeader } from '../Table/DataTable';
import { useTheme } from '@mui/material/styles';

export default function ColumnsButton({ 
    headers,
    setHeaders,
    isDisabled,
 }: { 
    headers: TableHeader[], 
    setHeaders: Dispatch<SetStateAction<TableHeader[]>>,
    isDisabled: boolean,
}) {
    const theme = useTheme();
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    
    const handleHeaders = (e: ChangeEvent<HTMLInputElement>, header: TableHeader) => {
        setHeaders(headers.map(h => {
            if (h.value === header.value) {
                return {
                    ...h,
                    isShown: e.target.checked,
                }
            } else {
                return {...h}
            }
        }))
    };




    return (
        <div>
            <Buttons 
                type={isDisabled ? 'disabled' : 'tertiary'}
                styling='solid'
                id='column-button'
                label='Columns'
                startingAdornment={<ColumnsIcon/>}
                endingAdornment={open ? <CloseIcon/> : <OpenIcon/>}
                action={handleClick}
            />
            <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                sx={{
                    marginTop: '8px',
                    maxHeight: '400px',
                    '& .MuiMenu-list': {
                        padding: 0,
                    }
                }}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right",
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                  }}
                MenuListProps={{
                'aria-labelledby': 'basic-button',
                }}
            >
                {headers.slice(1).map((header, i) => (
                    <MenuItem key={i} sx={{
                        fontFamily: 'Montserrat',
                        fontWeight: 'medium',
                        padding: 0,
                    }} onClick={(e:any) => {e.stopPropagation();}}>
                        <label 
                            style={{
                                padding: '12px 20px',
                                backgroundColor: `${header.isShown ? theme.palette.primary.light : '#ffffff'}`
                            }}
                            htmlFor={`${header.value}-column`} 
                            className={`${header.isShown ? 'text-primary' : 'text-default'} hover:cursor-pointer text-left font-medium flex justify-start items-center gap-3 w-full h-full`}
                        >
                            <input id={`${header.value}-column`} type='checkbox' onChange={(e: ChangeEvent<HTMLInputElement>) => handleHeaders(e, header)} checked={header.isShown} className='accent-primary'/>
                            <p className='text-nowrap'>{header.label}</p>
                        </label>
                    </MenuItem>
                ))}
            </Menu>
        </div>

    )
}